import { render } from "./general_query.vue?vue&type=template&id=08cfd4b8&scoped=true"
import script from "./general_query.vue?vue&type=script&lang=js"
export * from "./general_query.vue?vue&type=script&lang=js"

import "./general_query.vue?vue&type=style&index=0&id=08cfd4b8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08cfd4b8"]])

export default __exports__